import { FloatingBarAdminController } from './floating-bar-admin.controller.js'

function floatingBarAdmin () {
  return {
    restrict: 'E',
    scope: {
      selectedTemplates: '=',
      selectedCollections: '=',
      onUnselectAllAssets: '&',
      location: '=',
      onOpenBulkTemplateDialog: '&',
      onOpenArchiveTemplateDialog: '&',
      isProductList: '=',
      isArchivedFilter: '='
    },
    templateUrl: '/arts/directives/floating-bar-admin/floating-bar-admin-directive.html?$$REVISION$$',
    controller: FloatingBarAdminController
  }
}

export { floatingBarAdmin }
